// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"ss_a bht_rc bht_qx bht_xr","ContestPosts__more":"ss_b bht_vu bht_b bht_va bht_sv"};